import React, { Component } from 'react';
import Field from 'redux-form/lib/Field';
import Alert from 'react-bootstrap/lib/Alert';
import Button from 'react-bootstrap/lib/Button';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import FieldFormGroup from '../FieldFormGroup';

class CreateEpisode extends Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    const { anyTouched, error, handleSubmit, submitting } = this.props;
    return (
      <div>
        <form onSubmit={handleSubmit} id="form1">
          {anyTouched && error && <Alert bsStyle="danger">{error}</Alert>}
          <div>
            <Field
              name="title"
              placeholder="Type a name here"
              component={FieldFormGroup}
              type="text"
            />
          </div>
          <FormGroup>
            <Button
              bsStyle="primary"
              block
              type="submit"
              bsSize="large"
              disabled={submitting}
            >
              Create Episode
            </Button>
          </FormGroup>
        </form>
      </div>
    );
  }
}

export default CreateEpisode;
